import { todayTimeline } from '@/mocks/buzz';

export default function TodayBrief() {
  return (
    <section id="today" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="font-display text-3xl text-coral-500 md:text-4xl">今日速览</p>
          <h2 className="mt-2 text-2xl font-black leading-snug md:text-3xl">今天这口瓜，一分钟吃完</h2>
          <p className="mt-2 max-w-xl text-sm leading-6 text-ink-soft md:text-base">
            按时间线滚动更新的当日要闻速览，只看重点、不留水分，划到哪儿补到哪儿。
          </p>
        </div>
        <span className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-leaf-50 px-4 py-2 text-xs font-bold text-leaf-600">
          <i className="ri-time-line" /> 更新于今日 22:00
        </span>
      </div>

      <ol className="relative mt-10 grid gap-5 border-l-2 border-coral-100 pl-6 md:pl-8 lg:grid-cols-2">
        {todayTimeline.map((item, i) => (
          <li key={i} className="relative">
            <span className="absolute -left-[38px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-coral-200 bg-paper md:-left-[46px]">
              <span className="h-1.5 w-1.5 rounded-full bg-coral-500" />
            </span>
            <article className="rounded-2xl border border-paper bg-card p-5 transition-colors hover:border-coral-200">
              <div className="flex items-center gap-2 text-xs">
                <span className="font-mono font-bold text-coral-500">{item.time}</span>
                <span className="rounded-full bg-paper px-2.5 py-0.5 font-bold text-ink-soft">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-3 text-base font-black leading-snug text-ink md:text-lg">{item.title}</h3>
              <p className="mt-2 text-sm leading-6 text-ink-soft">{item.summary}</p>
            </article>
          </li>
        ))}
      </ol>
    </section>
  );
}